import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "customer", phone: "", city: "", target: "marriage" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(form);
      toast.success("Account created!");
      nav(u.role === "venue_owner" ? "/owner" : "/account");
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] grid md:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-16 order-2 md:order-1">
        <form onSubmit={submit} className="w-full max-w-md space-y-3" data-testid="register-form">
          <div>
            <h1 className="font-display text-4xl">Create account</h1>
            <p className="text-sm text-neutral-600 mt-1">Already have one? <Link className="text-[color:var(--wine)] underline" to="/login">Sign in</Link></p>
          </div>
          <div className="flex gap-2 p-1 rounded-full bg-[color:var(--ivory-2)]">
            {["customer","venue_owner"].map(r=>(
              <button type="button" key={r} onClick={()=>setForm({...form, role: r})} className={`flex-1 px-4 py-2 rounded-full text-sm ${form.role===r ? "bg-[color:var(--wine)] text-[color:var(--gold-2)]" : ""}`} data-testid={`role-${r}`}>
                {r === "customer" ? "I'm planning a wedding" : "I own a venue"}
              </button>
            ))}
          </div>
          <input required placeholder="Full name" value={form.name} onChange={e=>setForm({...form, name:e.target.value})} className="w-full px-4 py-3 rounded-lg border" data-testid="reg-name"/>
          <input type="email" required placeholder="Email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} className="w-full px-4 py-3 rounded-lg border" data-testid="reg-email"/>
          <input required type="password" placeholder="Password (min 8 chars)" value={form.password} onChange={e=>setForm({...form, password:e.target.value})} className="w-full px-4 py-3 rounded-lg border" data-testid="reg-password"/>
          <div className="grid grid-cols-2 gap-2">
            <input placeholder="Phone" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})} className="px-4 py-3 rounded-lg border"/>
            <input placeholder="City" value={form.city} onChange={e=>setForm({...form, city:e.target.value})} className="px-4 py-3 rounded-lg border"/>
          </div>
          {form.role === "customer" && (
            <select value={form.target} onChange={e=>setForm({...form, target:e.target.value})} className="w-full px-4 py-3 rounded-lg border">
              <option value="marriage">Marriage</option>
              <option value="reception">Reception</option>
              <option value="anniversary">Anniversary</option>
              <option value="engagement">Engagement</option>
              <option value="other">Other event</option>
            </select>
          )}
          <button disabled={busy} className="btn-wine w-full justify-center" data-testid="reg-submit">{busy ? "Creating…" : "Create account"}</button>
        </form>
      </div>
      <div className="hidden md:block relative order-1 md:order-2">
        <img src="https://images.pexels.com/photos/12688995/pexels-photo-12688995.jpeg?auto=compress&cs=tinysrgb&h=1200" className="w-full h-full object-cover"/>
        <div className="absolute inset-0 hero-overlay"/>
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--gold-2)]">Join Shubh Muhurat</div>
          <div className="font-display text-4xl mt-2">Grand weddings begin with the perfect stage.</div>
        </div>
      </div>
    </div>
  );
}
